export const DataBrandsOne = {
  subTitle: "Nos partenaires",
  title: "",
  items: [
    { id: 1, logo: "assets/images/brand/brand-01.png" },
    { id: 2, logo: "assets/images/brand/brand-02.png" },
    { id: 3, logo: "assets/images/brand/brand-03.png" },
    { id: 4, logo: "assets/images/brand/brand-04.png" },
    { id: 5, logo: "assets/images/brand/brand-05.png" },
    { id: 6, logo: "assets/images/brand/brand-06.png" },
    { id: 7, logo: "assets/images/brand/brand-07.png" },
    { id: 8, logo: "assets/images/brand/brand-08.png" },
    { id: 9, logo: "assets/images/brand/brand-09.png" },
    { id: 10, logo: "assets/images/brand/brand-10.png" },
    { id: 11, logo: "assets/images/brand/brand-11.png" },
    { id: 12, logo: "assets/images/brand/brand-12.png" },
    { id: 13, logo: "assets/images/brand/brand-13.png" },
    { id: 14, logo: "assets/images/brand/brand-14.png" },
    { id: 15, logo: "assets/images/brand/brand-15.png" },
    { id: 16, logo: "assets/images/brand/brand-16.png" },
    { id: 17, logo: "assets/images/brand/brand-17.png" },
    { id: 18, logo: "assets/images/brand/brand-18.png" },
  ],
};
